import { getHelpCenterAri } from '@helpcenter/meta';

export const getProductIdentifierAttributes = (experienceId: string) => ({
	experienceId,
	helpcenterId: getHelpCenterAri().split('/').pop(),
});
